import {
  ANALYTICS_SET_PAGE_NAME,
  ANALYTICS_SET_PAGE_SOURCE,
  ANALYTICS_SET_PURCHASE_SOURCE,
  SET_SOURCE,
} from '../Types';

/*
  Have to use GLOBAL_CONFIG here
  Can't use getDefaultConfig() here since can't access store before initialization
*/
const { rootDomain } = GLOBAL_CONFIG;

const initialState = {
  source: null,
  pageStartSource: document.referrer === `${rootDomain}/` ? 'marketing landing' : 'other',
  selected_plan: null,
  pageName: {},
  purchaseSource: '',
};

export const tracking = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_SOURCE:
      if (typeof payload === 'string' && payload.length > 0) {
        return { ...state, source: payload };
      }
      return state;
    case ANALYTICS_SET_PAGE_SOURCE:
      return { ...state, pageStartSource: payload };
    case ANALYTICS_SET_PAGE_NAME:
      return { ...state, pageName: { ...payload } };
    case ANALYTICS_SET_PURCHASE_SOURCE:
      return { ...state, purchaseSource: payload };
    default:
      return state;
  }
};
